import State from './types'

const initialState: State = {
    count: undefined,
}

export default initialState
